import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./houseCarousel.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./houseCarousel.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/houseCarousel.vue?vue&type=script&lang=js&
// module id = 168
// module chunks = 0